import React, { useEffect, useState } from "react";
import axios from "axios";
import { usecdotStore } from "../../components/cdotStore";
import { toast } from "react-toastify";

const ClockButton = () => {
  const baseURL = process.env.REACT_APP_API_URL;

  const [isClockedIn, setIsClockedIn] = useState(false);
  const [clockInTime, setClockInTime] = useState("");
  const [clockOutTime, setClockOutTime] = useState("");
  const [loading, setLoading] = useState(false);

  const username = usecdotStore((state) => state.username);
  const emp_id = usecdotStore((state) => state.emp_id);
  const emp_department = usecdotStore((state) => state.emp_department);
  const [attendanceId, setAttendanceId] = useState("");

  const [showWorkModal, setShowWorkModal] = useState(false);
  const [workStatus, setWorkStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ✅ Load from localStorage
  useEffect(() => {
  const checkAttendance = async () => {
    const formatDate = (date) => {
    const d = new Date(date);
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    return `${d.getFullYear()}-${month}-${day}`;
  };
    const now = new Date();
    try {
      const response = await axios.get(
        `${baseURL}attendance/check/${formatDate(now)}/${username}`
      );

      const data = response.data;
      setClockInTime(response.data?.[0]?.login_at);
      console.log("Check API 👉", data);console.log("Clock in 👉", response.data?.[0]?.login_at);

     const attendanceId = response.data?.[0]?.id;
     const logout_at = response.data?.[0]?.logout_at;
      if (attendanceId) {
        if(logout_at){
         setIsClockedIn(false); 
        }else{
        setAttendanceId(attendanceId);
        setIsClockedIn(true);
        }
      } else {
        setIsClockedIn(false);
      }

    } catch (error) {
      console.log("Check error 👉", error);
    }
  };

  if (username) {
    checkAttendance();
  }
}, [username]);

  const formatDate = (date) => {
    const d = new Date(date);
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    return `${d.getFullYear()}-${month}-${day}`;
  };

  const formatTime = (date) => {
    const d = new Date(date);
    const hours = ("0" + d.getHours()).slice(-2);
    const minutes = ("0" + d.getMinutes()).slice(-2);
    return `${hours}:${minutes}`;
  };

  const handleClockInOut = async () => {
    if (loading) return;
    setLoading(true);

    const now = new Date();

    const payload = {
      username: username,
      attendance_date: formatDate(now),
      employee_id: emp_id,
      attendance: "Present",
      login_at: !isClockedIn ? formatTime(now) : clockInTime,
      logout_at: isClockedIn ? formatTime(now) : "",
      login_date: formatDate(now),
      login_month: ("0" + (now.getMonth() + 1)).slice(-2),
      login_year: now.getFullYear().toString(),
      department_id: emp_department,
    };

    try {
      const response = await axios.post(baseURL + "attendance", payload);

      if (response.status === 200 || response.status === 201) {

        if (!isClockedIn) {
          // ✅ CLOCK IN
          localStorage.setItem("attendance", JSON.stringify({
            clockedIn: true,
            time: now.toISOString(),
            emp_id: emp_id
          }));

          setClockInTime(formatTime(now));
          setIsClockedIn(true);
          toast.success("Clock In successful!");

        } else {
          // ✅ CLOCK OUT
          localStorage.removeItem("attendance");

          setClockOutTime(formatTime(now));
          setIsClockedIn(false);
          toast.success("Clock Out successful!");
        }

      } else {
        toast.error("Server error");
      }

    } catch (error) {
      console.log(error);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };
  const calculateLogTime = (inTime, outTime) => {
  if (!inTime || !outTime) return "00.00"; // ✅ prevent crash

  const [inH, inM] = inTime.split(":").map(Number);
  const [outH, outM] = outTime.split(":").map(Number);

  const inDate = new Date();
  inDate.setHours(inH, inM, 0);

  const outDate = new Date();
  outDate.setHours(outH, outM, 0);

  if (outDate < inDate) {
    outDate.setDate(outDate.getDate() + 1);
  }

  const diffMs = outDate - inDate;
  const totalMinutes = Math.floor(diffMs / 60000);

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  

  return `${hours}.${("0" + minutes).slice(-2)}`;
};
const handleClockOutClick = () => {
  setShowWorkModal(true);
};
const handleClockOut = async () => {
  const now = new Date(); 
  if (!workStatus || workStatus.trim() === "") {
    toast.error("Please submit work status before clock out!");
    handleClockOutClick();
    return;
  }

  if (attendanceId) {
    const logoutTime = formatTime(now);

    const payload = {
      logout_at: logoutTime,
      log_time: calculateLogTime(clockInTime, logoutTime)
    };

    try {
      const response = await axios.put(
        `${baseURL}attendance/${attendanceId}`,
        payload
      );

      if (response.status === 200 || response.status === 201) {
        setClockOutTime(logoutTime);
        setIsClockedIn(false);
        toast.success("Clock Out successful!");
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong!");
    }
  }
};

const handleSubmitWorkStatus = async () => {
  if (!workStatus.trim()) {
    toast.error("Work status is required!");
    return;
  }

  setIsSubmitting(true);
const payload = {
      work_status: workStatus,      
    };
  try {
   
    const res = await axios.put(
        `${baseURL}attendance/${attendanceId}`,
        payload
      );

    if (res.status === 200 || res.status === 201) {
      toast.success("Work status submitted!");
      handleClockOut();
    }
  } catch (err) {
    console.log(err);
    toast.error("Failed to submit work status");
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <button
        onClick={isClockedIn ? handleClockOut:handleClockInOut}
        disabled={loading}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          backgroundColor: isClockedIn ? "#e74c3c" : "#2ecc71",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer"
        }}
      >
        {loading
          ? "Processing..."
          : isClockedIn
          ? "Clock Out"
          : "Clock In"}
      </button>

      <div style={{ marginTop: "20px" }}>
        {clockInTime && (
          <p>
            <strong>Clock In:</strong>  {clockInTime}
          </p>
        )}
        {clockOutTime && (
          <p>
            <strong>Clock Out:</strong> {clockOutTime}
          </p>
        )}
      </div>

      {showWorkModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
    <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-6">
      
      <h2 className="text-lg font-semibold mb-3">Submit Work Status</h2>

      <textarea
        value={workStatus}
        onChange={(e) => setWorkStatus(e.target.value)}
        placeholder="Enter your work summary..."
        className="w-full border rounded p-2 mb-4"
        rows={4}
      />

      <div className="flex justify-end gap-2">
        <button
          onClick={() => setShowWorkModal(false)}
          className="px-4 py-2 border rounded"
        >
          Cancel
        </button>

        <button
          onClick={handleSubmitWorkStatus}
          className="px-4 py-2 bg-purple-600 text-white rounded"
        >
          Submit & Clock Out
        </button>
      </div>

    </div>
  </div>
)}

    </div>
  );
};

export default ClockButton;